define('NavigationHelper.Fix', [
    'NavigationHelper.Plugins.Modals.Fix'
],
function NavigationHelperFix(

) {
    'use strict';

    return {};
});

